import { TriangleAlert } from "lucide-react";
import { useSEO } from "../hooks/useSEO";

const PolicyShell = ({ kicker, title, children, testid }) => (
  <div data-testid={testid} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <div className="sb-mono-label">{kicker}</div>
    <h1 className="mt-2 text-4xl sm:text-5xl font-semibold text-[#1B3A5C] tracking-tight" style={{ fontFamily: "Outfit" }}>
      {title}
    </h1>
    <div className="mt-10 space-y-6 text-[#475569] leading-relaxed text-[15px]">{children}</div>
  </div>
);

const H = ({ children }) => (
  <h2 className="text-xl font-medium text-[#1B3A5C] mt-10 mb-2" style={{ fontFamily: "Outfit" }}>
    {children}
  </h2>
);

const Compliance = () => {
  useSEO({
    title: "Research-use disclaimer · Compliance",
    description: "Sterling Bio research-use disclaimer. All products are supplied for in-vitro laboratory research only and are not for human or veterinary use.",
    path: "/compliance",
  });

  return (
  <PolicyShell kicker="Compliance" title="Research-use disclaimer" testid="compliance-page">
    <div className="border border-[#B91C1C]/20 bg-[#FEF2F2] p-5 flex gap-3">
      <TriangleAlert className="w-5 h-5 text-[#B91C1C] shrink-0 mt-0.5" />
      <p className="text-sm text-[#7f1d1d] leading-relaxed">
        <strong>Strictly not for human consumption.</strong> All products supplied by Sterling Bio
        Ltd are intended exclusively for in-vitro laboratory research and are not for human or
        veterinary use, food, cosmetic, household or commercial application.
      </p>
    </div>

    <H>Who can purchase</H>
    <p>
      Sterling Bio products are sold to qualified researchers, accredited research institutions
      and laboratory professionals. By placing an order, you confirm:
    </p>
    <ul className="list-disc list-outside pl-6 space-y-2">
      <li>You are at least 18 years of age.</li>
      <li>You are a qualified researcher or affiliated with a registered research entity.</li>
      <li>You will not administer the products to humans or animals.</li>
      <li>You will store, handle and dispose of products in accordance with applicable laws and good laboratory practice.</li>
    </ul>

    <H>Regulatory status</H>
    <p>
      The products supplied are not approved by the MHRA, FDA or any other regulatory body for
      human or veterinary use. They have not undergone clinical trials, safety evaluations or
      pharmacological studies appropriate for medicinal use.
    </p>

    <H>Quality assurance</H>
    <p>
      Every batch is verified by HPLC and mass spectrometry. Certificates of analysis are
      available on request. Products are supplied lyophilised in sterile vials and shipped in
      tamper-evident packaging.
    </p>

    <H>Liability</H>
    <p>
      Sterling Bio Ltd assumes no responsibility for misuse of any product supplied. The buyer
      assumes full responsibility for compliance with applicable laws and regulations governing
      the storage, handling, use and disposal of these materials in their jurisdiction.
    </p>

    <H>Contact</H>
    <p>
      Questions regarding compliance can be sent to our team by email during UK business
      hours.
    </p>
  </PolicyShell>
  );
};

export default Compliance;
